module.exports = __webpack_public_path__ + "img/2.5474a1b3.jpeg";